function removeSubmenuHeadingIfSingleChild(){
    const sublists = document.querySelectorAll('.wt-page-nav-mega__sublist');
    sublists.forEach(sublist => {
    const children = sublist.querySelectorAll(
        '.wt-page-nav-mega__sublist__item.wt-page-nav-mega__sublist__item--child.wt-page-nav-mega__sublist--parent'
    );

    if (children.length === 1) {
        const child = children[0];

        const link = child.querySelector(
        '[data-menu-level="2"].wt-page-nav-mega__sublist__link.wt-page-nav-mega__sublist__link--parent'
        );

        // const mainLink = child.parentNode.parentNode.parentNode.querySelector('[data-menu-level="1"]');

        // if(mainLink){
        //     mainLink.classList.add("submenu-opened","always-open")
        // }

        if (link) {
            if (window.innerWidth >= 1200) {
                link.style.display = "";
                return;
            }

            link.style.display="none";
        }
    }
    });

}

function setupNavHoverAnimation(){
    if (window.innerWidth < 1200) return;

    const navSublinks = document.querySelectorAll('.wt-page-nav-mega__sublist .wt-page-nav-mega__sublist__item.wt-page-nav-mega__sublist__item--child.wt-page-nav-mega__sublist--parent');

    console.log(navSublinks);

    navSublinks.forEach((navSublink, index, arr) => {
        navSublink.addEventListener('mouseenter', () => {
            arr.forEach((sibling, i) => {
            if (i != index) sibling.classList.add("blur")
            });
        });
        navSublink.addEventListener('mouseleave', () => {
            arr.forEach(sibling => sibling.classList.remove("blur"));
        });
    });
}

function checkSingleImageGallery(){
    const galleries = document.querySelectorAll(".mega-menu__gallery");

  galleries.forEach(gallery => {
    if (gallery.children.length === 1) {
      gallery.classList.add("single");
    }
  });
}

document.addEventListener("DOMContentLoaded", ()=>{
    setupNavHoverAnimation();
    removeSubmenuHeadingIfSingleChild();
    checkSingleImageGallery();
})

window.addEventListener("resize", () => {
    removeSubmenuHeadingIfSingleChild();
});
